import React from 'react'

import shivshankar_lawn from '../assets/shivshankar lawn.jpg'
import kamlesh_b_lawn from '../assets/kamlesh b celeb.jpg'
import shubham_lawn from '../assets/shubham lawn.jpg'
import gosawi_celeb from '../assets/gosawi celeb.jpeg'

export const Lawndata = [

    {
        id: 1,
        name: "Shivshankar Lawn",
        address: "Kharbi Rd, New Diamond Nagar, Shaktimata Nagar, Kharbi, Nagpur, Maharashtra 440024",
        contact: "9923314198 / 8329775561",
        img: shivshankar_lawn
    },

    {
        id: 2,
        name: "Kamlesh Bhadade Banquet Hall & Lawn",
        address: "Tarodi, Near Bujh Gram Panchanyat Opposite Chattarpur Farms Bhandara Road, Four, Lane Highway, Nagpur, Maharashtra 441202",
        contact: "9923314198 / 8329775561",
        img: kamlesh_b_lawn
    },

    {
        id: 3,
        name: "Shubham Lawn",
        address: "Navnath ITI Road 22- B Dighori Busstop, Plot no. 22, Narsala Main Rd, near Sarvashree School, Bank Colony, Indra Nagar, Narsala, Nagpur, Maharashtra 440034",
        contact: "9923314198 / 8329775561",
        img: shubham_lawn
    },

    {
        id: 4,
        name: "Gosavi Celebration Hall",
        address: "45H9+4J3, bujurg road, Tarodi Bk, Bidgaon., Maharashtra 441202",
        contact: "9923314198 / 8329775561",
        img: gosawi_celeb
    }
]
